export const HOSTILE_SPAWN_WEIGHTS = [
  { type: 'zombie', w: 0.19 },
  { type: 'skeleton', w: 0.12 },
  { type: 'skeleton_archer', w: 0.11 },
  { type: 'creeper', w: 0.13 },
  { type: 'spider', w: 0.11 },
  { type: 'enderman', w: 0.11 },
  { type: 'husk', w: 0.08 },
  { type: 'stray', w: 0.08 },
  { type: 'drowned', w: 0.07 }
];

export const PASSIVE_SPAWN_WEIGHTS = [
  { type: 'cow', w: 0.17 },
  { type: 'sheep', w: 0.16 },
  { type: 'pig', w: 0.16 },
  { type: 'chicken', w: 0.13 },
  { type: 'villager', w: 0.05 },
  { type: 'goat', w: 0.11 },
  { type: 'wild_boar', w: 0.11 },
  { type: 'duck', w: 0.08 }
];

export const MAX_HOSTILE_MOBS = 8;
export const HOSTILE_SPAWN_BASE_INTERVAL = 3.4;
export const HOSTILE_SPAWN_NIGHT_ACCEL = 0.8;

export const MOB_CONFIG = {
  zombie: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: true,
    speed: 1.9,
    hp: 20,
    meleeDamage: 3,
    meleeRange: 1.35,
    attackCd: 1.2,
    color: 0x4d8d44,
    drop: { itemId: 'rotten_flesh', min: 1, max: 2 }
  },
  skeleton: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: true,
    speed: 2.15,
    hp: 20,
    meleeDamage: 2,
    meleeRange: 1.35,
    attackCd: 1.1,
    color: 0xe5e5e5,
    drop: [
      { itemId: 'bone', min: 1, max: 2 },
      { itemId: 'arrow', min: 0, max: 2, chance: 0.72 }
    ]
  },
  skeleton_archer: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: true,
    speed: 1.8,
    hp: 20,
    rangedDamage: 3,
    rangedRange: 16,
    shootCd: 3.0,
    color: 0xd6d6d6,
    drop: [
      { itemId: 'arrow', min: 1, max: 3 },
      { itemId: 'bone', min: 0, max: 1, chance: 0.55 }
    ]
  },
  creeper: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: false,
    speed: 2.25,
    hp: 20,
    explodeDamage: 30,
    explodeRange: 4.2,
    fuseTime: 2.2,
    color: 0x57b44b,
    drop: { itemId: 'gunpowder', min: 1, max: 2 }
  },
  ender_dragon: {
    behavior: 'boss',
    model: 'dragon',
    speed: 6.2,
    hp: 320,
    meleeDamage: 8,
    meleeRange: 3.6,
    attackCd: 1.15,
    color: 0x2a2236,
    accentColor: 0x6c4fd2,
    drop: [
      { itemId: 'diamond_gem', min: 8, max: 14 },
      { itemId: 'ender_eye', min: 2, max: 5 }
    ]
  },
  spider: {
    behavior: 'hostile',
    model: 'quadruped',
    burnsInSun: false,
    speed: 2.5,
    hp: 16,
    meleeDamage: 2.5,
    meleeRange: 1.4,
    attackCd: 1.0,
    color: 0x2c2b2b,
    accentColor: 0x9b1b1b,
    drop: [
      { itemId: 'string', min: 1, max: 2 },
      { itemId: 'spider_eye', min: 1, max: 1, chance: 0.34 }
    ]
  },
  enderman: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: false,
    speed: 2.55,
    hp: 40,
    meleeDamage: 4,
    meleeRange: 1.55,
    attackCd: 1.15,
    color: 0x19161f,
    accentColor: 0x6c4fd2,
    drop: { itemId: 'ender_eye', min: 0, max: 1, chance: 0.58 }
  },
  husk: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: false,
    speed: 2.0,
    hp: 22,
    meleeDamage: 3.6,
    meleeRange: 1.4,
    attackCd: 1.08,
    color: 0x8f7344,
    accentColor: 0xb89966,
    drop: { itemId: 'rotten_flesh', min: 1, max: 2 }
  },
  stray: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: true,
    speed: 1.95,
    hp: 20,
    rangedDamage: 3.4,
    rangedRange: 17,
    shootCd: 2.9,
    meleeDamage: 2.2,
    meleeRange: 1.3,
    attackCd: 1.2,
    color: 0xc7d6df,
    accentColor: 0x8ea4b2,
    drop: [
      { itemId: 'arrow', min: 1, max: 3 },
      { itemId: 'bone', min: 1, max: 2, chance: 0.85 }
    ]
  },
  pillager: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: false,
    speed: 2.12,
    hp: 24,
    rangedDamage: 4.4,
    rangedRange: 18,
    shootCd: 2.6,
    meleeDamage: 3.0,
    meleeRange: 1.35,
    attackCd: 1.0,
    color: 0x6a6f78,
    accentColor: 0x4a4f57,
    drop: [
      { itemId: 'arrow', min: 1, max: 3 },
      { itemId: 'emerald', min: 0, max: 1, chance: 0.4 }
    ]
  },
  raider_brute: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: false,
    speed: 2.35,
    hp: 30,
    meleeDamage: 5.4,
    meleeRange: 1.45,
    attackCd: 0.95,
    color: 0x5a4437,
    accentColor: 0x9e8666,
    drop: [
      { itemId: 'leather', min: 0, max: 2, chance: 0.68 },
      { itemId: 'emerald', min: 0, max: 1, chance: 0.35 }
    ]
  },
  drowned: {
    behavior: 'hostile',
    model: 'humanoid',
    burnsInSun: false,
    spawnInWater: true,
    preferWater: true,
    speed: 1.82,
    hp: 24,
    meleeDamage: 4.2,
    meleeRange: 1.42,
    attackCd: 1.05,
    color: 0x3f6f6f,
    accentColor: 0x6f9a92,
    drop: [
      { itemId: 'rotten_flesh', min: 1, max: 2 },
      { itemId: 'coal', min: 0, max: 1, chance: 0.28 }
    ]
  },

  cow: {
    behavior: 'passive',
    model: 'quadruped',
    speed: 1.45,
    hp: 16,
    color: 0x6c4f36,
    accentColor: 0xd7c2a0,
    drop: [
      { itemId: 'beef_raw', min: 1, max: 3 },
      { itemId: 'leather', min: 0, max: 2, chance: 0.75 }
    ]
  },
  sheep: {
    behavior: 'passive',
    model: 'quadruped',
    speed: 1.38,
    hp: 14,
    color: 0xe6e6e6,
    accentColor: 0xc6c6c6,
    drop: [
      { itemId: 'mutton_raw', min: 1, max: 2 },
      { itemId: 'wool', min: 1, max: 2, chance: 0.9 }
    ]
  },
  pig: {
    behavior: 'passive',
    model: 'quadruped',
    speed: 1.42,
    hp: 15,
    color: 0xd98da1,
    accentColor: 0xc96f88,
    drop: { itemId: 'pork_raw', min: 1, max: 3 }
  },
  chicken: {
    behavior: 'passive',
    model: 'chicken',
    speed: 1.62,
    hp: 10,
    color: 0xf2efe2,
    accentColor: 0xd7a167,
    drop: [
      { itemId: 'chicken_raw', min: 1, max: 2 },
      { itemId: 'feather', min: 0, max: 2, chance: 0.85 }
    ]
  },
  goat: {
    behavior: 'passive',
    model: 'quadruped',
    speed: 1.72,
    hp: 12,
    color: 0xd5ccc0,
    accentColor: 0x9a8f80,
    drop: [
      { itemId: 'mutton_raw', min: 1, max: 2 },
      { itemId: 'leather', min: 0, max: 1, chance: 0.35 }
    ]
  },
  wild_boar: {
    behavior: 'passive',
    model: 'quadruped',
    speed: 1.65,
    hp: 16,
    color: 0x5b4332,
    accentColor: 0x7b5d45,
    drop: [
      { itemId: 'pork_raw', min: 1, max: 3 },
      { itemId: 'leather', min: 0, max: 1, chance: 0.55 }
    ]
  },
  duck: {
    behavior: 'passive',
    model: 'chicken',
    spawnInWater: true,
    preferWater: false,
    speed: 1.7,
    hp: 10,
    color: 0xf0eee2,
    accentColor: 0xb4935c,
    drop: [
      { itemId: 'chicken_raw', min: 1, max: 2 },
      { itemId: 'feather', min: 1, max: 3, chance: 0.9 }
    ]
  },
  villager: {
    behavior: 'passive',
    model: 'humanoid',
    speed: 1.15,
    hp: 20,
    color: 0x866140,
    accentColor: 0xd1ab84
  }
};

export function pickWeighted(entries) {
  const t = Math.random();
  let acc = 0;
  for (const entry of entries) {
    acc += entry.w;
    if (t <= acc) return entry.type;
  }
  return entries[0]?.type || 'zombie';
}
